import Helper from './Helper';

class Header {
  constructor(config = {}) {
    const {
      headerSelector, //header wrapper (menu open)
      burgerSelector, // burger toggle
      navigationSelector, //php menu
      navItemSelector, // clickable link
      initialActiveItemSelector, // ancestor-active
    } = config;

    this.header = document.querySelector(headerSelector);
    this.burgerToggle = document.querySelector(burgerSelector);
    this.navigation = document.querySelector(navigationSelector);
    this.navItems = document.querySelectorAll(navItemSelector);
    this.activeItemInit = document.querySelector(initialActiveItemSelector);

    this.archiveToggles = document.querySelectorAll('.js-archive-toggle');
    this.archive = document.querySelector('.wp-header-menu-archive');

    this.initActiveLink();
    this.bindEvents();

    // add margin top to content
    // document.querySelector('.content').style.marginTop = document.querySelector('.wp-header').offsetHeight + 'px';
  }

  bindEvents() {
    this.navItems.forEach(navItem => {
      navItem.addEventListener('click', (event) => this.navItemClick(event, navItem));
    });

    this.burgerToggle.addEventListener('click', (e) => {
      this.closeArchive();
      this.toggleMenu();
    })

    this.archiveToggles.forEach(archiveToggle => {
      archiveToggle.addEventListener('click', (event) => {
        this.closeMenu();
        this.toggleArchive();
      });
    })

    document.onkeydown = (evt) => {
      evt = evt || window.event;
      var isEscape = false;
      if ("key" in evt) {
        isEscape = evt.key === "Escape" || evt.key === "Esc";
      } else {
        isEscape = evt.keyCode === 27;
      }
      if (isEscape) {
        this.closeArchive();
        this.closeMenu();
      }
    };

  }


  // click handler for navItem
  navItemClick = (event, navItem) => {
    if (!event.target.classList.contains('menu__link--level-1')) {
      event.preventDefault();
    }
    this.removeActiveLink();
    navItem.parentNode?.classList.toggle('active');
  }

  // open active link
  initActiveLink() {
    this.activeItemInit?.classList.add('active');
  }


  // open menu
  bIsMenuOpen() {
    return this.header?.classList.contains('menu-open');
  }

  // open menu
  toggleMenu() {
    if (this.bIsMenuOpen()) {
      this.closeMenu();
    } else {
      this.closeArchive()
      this.openMenu();
    }
  }

  // open menu
  openMenu() {
    Helper.bodyDisableScroll();
    Helper.slideDown(this.navigation, 100).then(() => {
      this.header?.classList.add('menu-open');
    });
  }

  // close menu
  closeMenu() {
    Helper.bodyEnableScroll();
    Helper.slideUp(this.navigation, 100).then(() => {
      this.header?.classList.remove('menu-open');
    });
  }

  toggleArchive() {
    if (!this.bIsArchiveOpen()) {
      this.openArchive();
    } else {
      this.closeArchive();
    }
  }

  openArchive() {
    if (this.archive) {
      Helper.slideDown(this.archive, 100).then(() => {
        this.header?.classList.add('archive-open');
      });
    }

  }

  //close archive
  closeArchive() {
    if (this.archive && this.bIsArchiveOpen()) {
      Helper.slideUp(this.archive, 100).then(() => {
        this.header?.classList.remove('archive-open');
      });
    }
  }

  bIsArchiveOpen() {
    return this.header?.classList.contains('archive-open');
  }

  // remove active link on desktop for only one open item
  removeActiveLink() {
    if (Helper.isDesktop()) {
      this.navItems.forEach(navItem => {
        navItem.parentNode.classList.remove('active');
      });
    }
  }

}

export default Header;
